import React, { useEffect, useState } from "react";
import apiRequest from "../../functions/api";
import {
  Typography,
  Grid,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
  useMediaQuery,
  useTheme,
  DialogActions,
  Backdrop,
  Select,
  MenuItem,
  Chip,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useMessage } from "../../context/message-context";
import { useLocalStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Layout from "../shared/components/LayoutComponent";
import TelephoneInput from "../shared/components/TelephoneInput";
function MasterSonstige(props) {
  const { t } = useTranslation();
  const { sonstigeFelder, user, accessToken, bearbeitung, daten, setReload, reload, client, kinderBeantragen,reloadDaten } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedField, setSelectedField] = useState({});
  const [newValue, setNewValue] = useState("");
  const [newSelectValue, setNewSelectValue] = useState("");
  const [priv] = useLocalStorage(LOCAL_STORAGE_KEY.private);
  const { showErrorMessage, showSuccessMessage } = useMessage();
  const [terms, setTerms] = useState(false);
  const program = "LWEB02";
  const theme = useTheme();
  var isDarkMode = false;
  if (theme.palette.mode === "light") {
    isDarkMode = false;
  } else {
    isDarkMode = true;
  }
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [state, setState] = useState(false);

  useEffect(() => {
    if (!dialogOpen) {
      setNewValue("");
    }
  }, [dialogOpen]);

  const feldAusgewaehlt = (feld) => {
    setSelectedField(feld);
    setDialogOpen(true);
    if (feld.antrag) {
      setNewValue(feld.antragsDaten.neuerInhalt);
    }
  };

  const sendChange = (feld) => {
    const payload = {
      mandant: client,
      program: program,
      feld: feld,
      newValue: newValue,
      antragVorhanden: feld.antrag,
      antragsKey: feld?.antragsDaten?.key,
      statement: "SEND_CHANGE",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, changeCb);
  };
  const changeCb = (response) => {
    if (response.status === 200) {
      setSelectedField([]);
      setNewValue("");
      reloadDaten();
      setDialogOpen(false);
      showSuccessMessage("Änderungsantrag erfolgreich gestellt");
    }
  };
  const deleteAntrag = (key) => {
    const payload = {
      mandant: client,
      program: program,
      key: key,
      statement: "DELETE_ANTRAG",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, deleteCb);
  };
  const deleteCb = (response) => {
    if (response.status === 200) {
      reloadDaten();
      setDialogOpen(false);
      showSuccessMessage("Änderungsantrag erfolgreich gelöscht");
    }
  };
  const submitCB = (response) => {
    closeDialog();
    setIsLoading(false);
    setState(!state);

    if (response?.data.message === "Kind bereits vorhanden") {
      showErrorMessage(response.data.message);
    }

    if (response.status === 200) {
      showSuccessMessage("Kind erfolgreich gemeldet");
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };

  const renderInputField = (feld) => {
    switch (feld.type) {
      case "text":
        return (
          <TextField fullWidth label={feld.label} value={newValue} onChange={(e) => setNewValue(e.target.value)} inputProps={{ maxLength: feld.maxLength }} />
        );
      case "select":
        return (
          <>
            <Typography>{feld.label}</Typography>
            <Select value={newValue} fullWidth onChange={(e) => {setNewValue(e.target.value)}}>
              {feld?.options?.sort((a, b) => a?.value > b.value)
                .map((option) => (
                  <MenuItem key={option.key} value={option.key}>
                    {option.value}
                  </MenuItem>
                ))}
            </Select>
          </>
        );
      case "number":
        return (
          <TextField
            fullWidth
            label={feld.label}
            value={newValue}
            onChange={(e) => setNewValue(e.target.value)}
            type="number"
            inputProps={{
              min: feld.min,
              max: feld.max,
            }}
          />
        );
      default:
        return null;
    }
  };
  return (
    <>
      {isLoading ? (
        <Grid item xs={12}>
          <CircularProgress />
        </Grid>
      ) : (
        <Grid item>
          <Grid container spacing={0.5}>
            <Grid item xs={12}>
              
              <Paper>
                <TableContainer>
                  <Table>
                    <TableBody>
                      {sonstigeFelder.map((feld, index) => {
                        
                        let displayValue=feld.value
                        if (feld.type==="select"){
displayValue=feld?.options?.find((e)=>e.key===feld.value)?.value
                        }
                        feld.displayValue=displayValue
                        return (
                          <TableRow
                            key={index}
                            sx={{
                              backgroundColor: feld.antrag ? (isDarkMode ? theme.palette.grey[800] : theme.palette.grey[200]) : "inherit",
                            }}
                          >
                            <TableCell width="125%">
                              {feld.antrag ? <Typography variant="caption" color={"red"}>{t("Änderung bereits beantragt")}</Typography> : ""}                       
                              <Typography>{t(feld.label)}</Typography>
                              {fullScreen && <Typography variant="body2">{displayValue}</Typography>}
                            </TableCell>
                            <TableCell width={"20%"} align="right">
                              {!fullScreen && (
                                <Typography component={"div"} variant="body2">                              
                                  {displayValue}
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell align="right" width={"5%"}>
                              <IconButton
                                color="primary"
                                disabled={feld.bearbeiten==="gesperrt"}
                                onClick={() => {
                                  feldAusgewaehlt(feld);
                                }}
                              >
                                <EditIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      )}
      <Dialog
        sx={{ "& .MuiDialog-paper": { width: "70%", maxHeight: 800 } }}
        maxWidth="md"
        open={dialogOpen}
        fullWidth={fullScreen}
        onClose={() => setDialogOpen(false)}
      >
        <DialogTitle>
          <Typography variant="h6" align={fullScreen ? "center" : ""}>
            {" "}
            {selectedField.antrag ? t("Antrag Ändern") : t("Daten ändern")}{" "}
          </Typography>
          {selectedField.antrag ? (
            <Typography align={fullScreen ? "center" : ""} fullWidth variant="body2" color="red">
              {t("Beantragt am:") + selectedField.antragsDaten.datum}
            </Typography>
          ) : (
            <Typography align={fullScreen ? "center" : ""} color={"primary"}>
              {selectedField.bearbeiten === "Antrag" ? "Änderungen werden beantragt" : "Änderungen werden direkt geschrieben"}
            </Typography>
          )}
        </DialogTitle>
        <DialogContent dividers>
          <Layout fullWidth>
            <Grid container>
              <Grid item xs={12}>
                <Box p={1}>
                  <Typography align={"center"}>{t("bisherige " + selectedField.label + ":")}</Typography>
                  <Typography align={"center"}>{ selectedField.displayValue}</Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box p={1}>{renderInputField(selectedField)}</Box>
              </Grid>
              <Grid item xs={12}>
                <Grid container justifyContent={"flex-end"}>
                  <Grid item></Grid>
                </Grid>
              </Grid>
            </Grid>
          </Layout>
          {selectedField.antrag && fullScreen && (
            <Button variant="outlined" onClick={() => deleteAntrag(selectedField.antragsDaten.key)}>
              <DeleteIcon />
              {t("Änderung löschen")}
            </Button>
          )}
        </DialogContent>
        <DialogActions>
          {selectedField.antrag && !fullScreen && (
            <Button variant="outlined" onClick={() => deleteAntrag(selectedField.antragsDaten.key)}>
              <DeleteIcon />
              {t("Änderung löschen")}
            </Button>
          )}
          <Button variant="outlined" fullWidth={fullScreen} onClick={() => setDialogOpen(false)}>
            {t("Zurück")}
          </Button>
          <Button variant="contained" fullWidth={fullScreen} color="primary" onClick={() => sendChange(selectedField)}>
            {t("Speichern")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default MasterSonstige;
